import type {offerNotesRouteApi} from "./-route-api";
import {z} from "zod";

// Notes are returned by the Customer aggregate; this search is local presentation state.
export const offerNotesSearchSchema = z.object({
  page: z.number().int().min(1).catch(1),
  perPage: z.number().int().min(1).max(100).catch(10),
  q: z.string().optional().catch(undefined),
  sortBy: z.enum(["title", "content", "editedAt"]).catch("title"),
  sortDir: z.enum(["asc", "desc"]).catch("asc"),
});
export type OfferNotesSearch = z.output<typeof offerNotesSearchSchema>;
export type OfferNotesNavigateFn = ReturnType<typeof offerNotesRouteApi.useNavigate>;
